import { PostingType } from 'app/library/posting/models/posting-type.model';
import { ICourseCatalogPostingStreamQuery } from '../interfaces/course-catalog-posting-stream-query.interface';
import { MaxbrainImage } from 'app/library/image-library/models/maxbrain-image.model';
import { PostingTranslation } from 'app/library/posting/models/posting-translation.model';
import { CourseCatalogCourseOffering } from './course-catalog-posting-course-offering.model';

export class CourseCatalogPostingStream {
    id: string;
    postingType: PostingType;
    image: MaxbrainImage;
    isUsingDefaultImage: boolean;
    kind: string;
    url: string;
    validFrom: string;
    validTo: string;
    article: {
        id: string;
        unique_id: string;
    };
    courseOffering: CourseCatalogCourseOffering;
    translation: PostingTranslation;
    urlSource: string;
    isBooked: boolean;
    numberOfVisibleListings: number;
    numberOfPublishedOfferings: number | null;

    isSelected?: boolean; // Frontend property

    constructor(query: ICourseCatalogPostingStreamQuery) {
        this.id = query.id.toString();
        this.postingType = new PostingType(query.posting_type);
        this.image = query.image ? new MaxbrainImage(query.image) : null;
        this.isUsingDefaultImage = query.is_using_default_image;
        this.kind = query.kind;
        this.url = query.url;
        this.validFrom = query.valid_from;
        this.validTo = query.valid_to;
        this.article = query.article
            ? {
                  id: query.article.id?.toString(),
                  unique_id: query.article.unique_id,
              }
            : null;
        this.courseOffering = query.course_offering ? new CourseCatalogCourseOffering(query.course_offering) : null;
        this.translation = query.translation ? new PostingTranslation(query.translation) : null;
        this.urlSource = query.url_source;
        this.isBooked = query.course_offering?.is_booked ?? query.is_booked ?? false;
        this.numberOfVisibleListings = query.course_offering?.number_of_visible_listings ?? query.number_of_visible_listings ?? 0;
        this.numberOfPublishedOfferings = query.category?.number_of_published_offerings ?? null;
    }
}
